import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    loadChildren: "./views/home/home.module#HomeModule"
  },
  {
    path: "products",
    loadChildren: "./views/products/shop.module#ShopModule"
  },
  {
    path: "product/:id",
    loadChildren: "./views/product/product.module#ProductModule"
  },
  {
    path: "projects",
    loadChildren: "./views/projects/projects.module#ProjectsModule"
  },
  {
    path: "contact-us",
    loadChildren: "./views/contact-us/contactus.module#ContactUsModule"
  },
  {
    path: "about-us",
    loadChildren: "./views/about-us/about-us.module#AboutUsModule"
  },
  {
    path: "**",
    redirectTo: "/"
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
